import { Box } from '@mui/material';
import React, { Component, lazy, Suspense } from 'react';
import { reportError } from '../config/sentry';

const ErrorPage = lazy(() => import('../pages/ErrorPage/Index'));

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    reportError(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box display="flex" alignItems="center" justifyContent="center" height="100%">
          <Suspense fallback={null}>
            <ErrorPage error_message="Oops! Looks like something went wrong." />
          </Suspense>
        </Box>
      );
    }

    return this.props.children;
  }
}
